import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmCreateDialogComponent } from './confirm-create-dialog.component';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { ServiceordreService } from 'src/app/api/services/serviceordre.service';
import moment from 'moment';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';

@Injectable({
  providedIn: 'root',
})
export class ConfirmCreateDialogService {
  today = new Date();
  constructor(private dialog: MatDialog, private serviceordreService: ServiceordreService) {}

  async hasOtherServiceordre(serviceaftaleno: number, deadline: Date): Promise<ServiceordreDto> {
    const ordrer = await this.serviceordreService
      .getServiceordrerForServiceaftale({
        caller: EGIS_SERVICE_CALLER,
        serviceaftaleNo: serviceaftaleno,
      })
      .toPromise();
    return this.getWarning(deadline, ordrer);
  }

  async Confirm(serviceaftaleno: number, opgavetype: string, deadline: Date): Promise<boolean> {
    const so = await this.hasOtherServiceordre(serviceaftaleno, deadline);
    return new Promise<boolean>((resolve) => {
      if (!so) resolve(true);
      else {
        const dlg = this.dialog.open<ConfirmCreateDialogComponent>(ConfirmCreateDialogComponent, {
          data: {
            serviceordre: so,
            opgavetype: opgavetype,
          },
        });
        dlg.afterClosed().subscribe((p) => {
          resolve(p);
        });
      }
    });
  }

  private getWarning(p: Date, orders: ServiceordreDto[]): ServiceordreDto | undefined {
    const from_deadline = moment(p.toOkDateString()).add(-1, 'd');
    const to_deadline = moment(p.toOkDateString()).add(1, 'd');
    const order_deadline = orders
      .filter(
        (o) =>
          moment(o.deadline) >= from_deadline &&
          moment(o.deadline) <= to_deadline &&
          o.serviceordreStateEnum != ServiceordreStatusEnum.Cancelled &&
          o.serviceordreStateEnum != ServiceordreStatusEnum.CompletedWithRejection
      )
      .shift();
    if (order_deadline) return order_deadline;

    const from_oprettid = moment(this.today.toOkDateString()).add(-1, 'd');
    const to_oprettid = moment(this.today.toOkDateString()).add(1, 'd');
    return orders
      .filter(
        (o) =>
          moment(o.createdOn) >= from_oprettid &&
          moment(o.createdOn) <= to_oprettid &&
          o.serviceordreStateEnum != ServiceordreStatusEnum.Cancelled &&
          o.serviceordreStateEnum != ServiceordreStatusEnum.CompletedWithRejection
      )
      .shift();
  }
}
